import React from 'react';
import { legends } from 'modals/parameter-connections/constants';

import cn from 'modals/parameter-connections/component/Components.module.scss';

export const Legend = () => (
  <div className={cn.legendWrapper}>
    {legends.map(({ id, color, status }) => (
      <div key={id} className={cn.content}>
        <div className={cn.circleLegend} style={{ backgroundColor: color }} />
        <span className={cn.text}>{status}</span>
      </div>
    ))}
  </div>
);
